export default __webpack_public_path__ + "static/media/isb-icon.2fe35795.webp";